import styles from './MailForm.module.scss';
import React, { useState } from 'react';

const MailForm = (props) => {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Wysyłanie wiadomości na podany adres e-mail
    const mailtoLink = `mailto:cometweb.kontakt@gmail.com?subject=Wiadomość ze strony&body=Imię i nazwisko: ${name}%0D%0AEmail: ${email}%0D%0ANumer telefonu: ${phone}%0D%0AWiadomość: ${message}`;
    window.location.href = mailtoLink;

    // Czyszczenie pól formularza
    setName('');
    setEmail('');
    setPhone('');
    setMessage('');
  };

  //

  // const input = document.getElementById('phone');

  // input.addEventListener('input', function(e) {
  //   const inputValue = e.target.value;
  //   const validInput = inputValue.replace(/[^0-9+-.]/g, '');
  //   e.target.value = validInput;
  // });

  return (
    <div className={styles.mailFormWrapper} ref={props.scrollRefs.sesja4}>
      {props.language === 'pl' &&
        <form onSubmit={handleSubmit}>
          <div className={styles.inputContainer}>
            <input
              type="text"
              id="name"
              placeholder="Imię i nazwisko"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className={styles.inputContainer}>
            <input
              type="email"
              id="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className={styles.inputContainer}>
            <input
              type="tel"
              id="phone"
              placeholder="Numer telefonu"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className={styles.inputContainer}>
            <textarea
              id="message"
              placeholder="Twoja wiadomość"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button className={styles.button} type="submit">Wyślij</button>
        </form>
      }
      {props.language === 'eng' &&
        <form onSubmit={handleSubmit}>
          <div className={styles.inputContainer}>
            <input
              type="text"
              id="name"
              placeholder="Name and surname"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className={styles.inputContainer}>
            <input
              type="email"
              id="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className={styles.inputContainer}>
            <input
              type="tel"
              id="phone"
              placeholder="Phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className={styles.inputContainer}>
            <textarea
              id="message"
              placeholder="Your message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button className={styles.button} type="submit">Send</button>
        </form>
      }
    </div>
  );
};

export default MailForm;